import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';
import { SidebarNav } from './SidebarNav';

const AppBody = (props) => {
    return (
      // <div>
      //   <NavMenu />
      //   <Container>
      //     {props.children}
      //   </Container>
      // </div>
      <div className="d-flex">
        <SidebarNav/>
        <main className="flex-grow-1">
          <Container>
            {props.children}
          </Container>
        </main>
      </div>
    );
}

export default AppBody;
